<template>
  <div>
    <Tabs
      :tabs="tabIcons"
      :view="view"
      @click="setView"
    />

    <div class="m-4">
      <div class="mt-8">
        <Pagination
          :page-index="index"
          :total-pages="30"
          :visible-pages-count="7"
          @click="changeIndex"
        />
      </div>

      <div class="inline-block">
        <div class="flex items-center justify-end mt-8">
          <SecondaryButton
            text="Close"
            @click="secondaryClick"
          />

          <PrimaryButton
            text="Send"
            icon="fas fa-paper-plane"
            class="ml-4"
            @click="primaryClick"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from '@/app/shared/components/navigation/tabs/tabs.vue';
import Pagination from '@/app/shared/components/navigation/pagination/pagination.vue';
import PrimaryButton from '@/app/shared/components/base/button/primaryButton.vue';
import SecondaryButton from '@/app/shared/components/base/button/secondaryButton.vue';

export default {
  name: 'Navigation',

  components: {
    Tabs,
    Pagination,
    PrimaryButton,
    SecondaryButton,
  },

  data() {
    return {
      view: 'Dashboard',

      index: 1,

      tabIcons: [
        { name: 'Dashboard', icon: 'fad fa-home' },
        { name: 'Contacts', icon: 'fad fa-users' },
        { name: 'Club', icon: 'fad fa-flag-alt' },
        { name: 'Competitions', icon: 'fad fa-golf-club' },
        { name: 'Tee Sheet', icon: 'fad fa-th-list' },
      ],
      tabs: [
        { name: 'Dashboard' },
        { name: 'Contacts' },
        { name: 'Club' },
        { name: 'Competitions' },
        { name: 'Tee Sheet' },
      ],
    };
  },

  mounted() {

  },

  methods: {
    changeIndex(index) {
      this.index = index;
    },

    setView(view) {
      this.view = view;
    },

    primaryClick() {

    },

    secondaryClick() {

    },
  },

};
</script>
